



















































































































































































































import { Vue } from "vue-property-decorator";

export default class TermsAndConditionsModal extends Vue {
        name: "terms-and-conditions"
}
